import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { useDispatch } from 'react-redux';
import loginImage from '../../../assets/img/homepage-img.png';
import { FooterInfoLink } from './FooterInfoLink';
import { LOCAL_STORAGE, ROLES, ROUTES, SSO } from '../../../constants';
import { decryptSearchString, popup, setLocalStorageItem } from '../../../utils';
import { startCase } from 'lodash';
import { setLoaderVisibility, setUserData } from '../../../redux';
import { connectSocket } from '../../../constants/socketClient';
export const Landing = () => {
    const encryptedSearch = window.location.search.slice(1);
    const decryptedSearch = decryptSearchString(encryptedSearch);
    const searchParams = decryptedSearch
        ? new URLSearchParams(decryptedSearch)
        : new URLSearchParams();
    const getCode = searchParams.get(SSO.GET_CODE);
    const isActive = searchParams.get('isActive') === '1' ? true : false;
    const token = searchParams.get(SSO.TOKEN);
    const { inProgress, instance } = useMsal();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setLoaderVisibility(true));
        const fetchData = async () => {
            try {
                if (!isActive && getCode === 'true') {
                    throw new Error('Account has been deactivated, contact SSC admin.');
                }
                if (getCode === 'true' && token && inProgress === SSO.STARTUP && isActive) {
                    const firstName = searchParams.get(SSO.FIRST_NAME);
                    const lastName = searchParams.get(SSO.LAST_NAME);
                    const userID = searchParams.get(SSO.USER_ID);
                    const refreshToken = searchParams.get(SSO.REFRESH_TOKEN);
                    const email = searchParams.get(SSO.EMAIL);
                    const role = searchParams.get(SSO.ROLE);
                    const image = searchParams.get(SSO?.PROFILE_IMAGE);
                    setLocalStorageItem(LOCAL_STORAGE.LOGIN_AT, Date.now());
                    if (role === ROLES.CSM) {
                        const socket = connectSocket(userID);
                        socket.on('connect', () => {
                            if (socket?.id) {
                                console.log('✅ Socket connected at login');
                            }
                            socket.emit('register-user', { user_id: userID });
                        });
                    }
                    if (token || firstName || lastName) {
                        setLocalStorageItem(LOCAL_STORAGE.AUTH_TOKEN, token);
                        setLocalStorageItem(LOCAL_STORAGE.ROLE_CODE, role);
                        setLocalStorageItem(
                            LOCAL_STORAGE.ROLE_NAME,
                            role === 'csm' ? role.toUpperCase() : startCase(role),
                        );
                        setLocalStorageItem(LOCAL_STORAGE.USER_ID, userID);
                        setLocalStorageItem(LOCAL_STORAGE.FIRST_NAME, firstName);
                        setLocalStorageItem(LOCAL_STORAGE.LAST_NAME, lastName);
                        setLocalStorageItem(LOCAL_STORAGE.FULL_NAME, `${firstName} ${lastName}`);
                        setLocalStorageItem(LOCAL_STORAGE.REFRESH_TOKEN, refreshToken);
                        setLocalStorageItem(LOCAL_STORAGE.EMAIL, email);
                    }
                    if (image !== 'null') {
                        dispatch(
                            setUserData({
                                firstName: firstName,
                                lastName: lastName,
                                imagePath: image || null,
                                role: role,
                            }),
                        );
                    } else {
                        dispatch(
                            setUserData({
                                firstName: firstName,
                                lastName: lastName,
                                role: role,
                            }),
                        );
                    }
                    navigate(ROUTES.ADMIN.DASHBOARD);
                }
            } catch (error) {
                popup('error', error?.message || error);
                navigate(ROUTES.ADMIN.LOGIN);
            } finally {
                dispatch(setLoaderVisibility(false));
            }
        };

        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [instance, inProgress, isActive, getCode, token]);
    return (
        <section className='row mx-0 ssc-login'>
            <div className='col-md-6 px-0 scc-login-left flex-column'>
                <div className='col-xl-8 col-lg-10 col-11 d-flex align-items-center justify-content-center'>
                    <Outlet />
                </div>
                <FooterInfoLink />
            </div>

            <div className='col-md-6 px-0 scc-login-right'>
                <div className='col-lg-10 col-11 d-flex align-items-center justify-content-center'>
                    <img src={loginImage} alt='img' className='img-fluid' />
                </div>
            </div>
        </section>
    );
};
